export default __webpack_public_path__ + "static/media/stats-container.47bc4cc7.png";